import React, { useState } from 'react';
import { Check, X } from 'lucide-react';
import EnterpriseInquiryModal from '../components/common/EnterpriseInquiryModal';
import '../styles/desktop/PricingPage.css';

const PricingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState('hr');

  const handleFreeStart = () => {
    window.location.href = '/login';
  };

  const handleProUpgrade = () => {
    window.location.href = '/login';
  };

  const handleConsultingLearn = () => {
    setSelectedPackage('hr');
    setIsModalOpen(true);
  };

  const handleRecruitLearn = () => {
    setSelectedPackage('recruiter');
    setIsModalOpen(true);
  };

  return (
    <div className="pricing-container">
      {/* 헤더 섹션 */}
      <div className="pricing-header">
        <h1 className="pricing-title">개인용 플랜</h1>
        <p className="pricing-subtitle">무료로 시작하고, 필요할 때 Pro로 업그레이드하세요.</p>
      </div>

      {/* 가격 표 섹션 */}
      <div className="pricing-table-wrapper">
        <table className="pricing-table">
          <thead>
            <tr>
              <th className="feature-column">
              </th>
              <th className="plan-column">
                <div className="plan-header">
                  <div className="plan-badge badge-free">체험용</div>
                  <h2 className="plan-name">Free</h2>
                </div>
              </th>
              <th className="plan-column plan-featured">
                <div className="recommended-badge">Recommended</div>
                <div className="plan-header">
                  <div className="plan-badge badge-pro">개인</div>
                  <h2 className="plan-name">Pro</h2>
                  <div className="plan-price">
                    <span className="price-amount">₩9,900</span>
                    <span className="price-period">/ 월 (VAT 포함)</span>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="feature-name">음성 이력서 컨설팅</td>
              <td className="feature-value">
                <div className="value-content">
                  <span>무제한</span>
                </div>
              </td>
              <td className="feature-value value-featured">
                <div className="value-content">
                  <span>무제한</span>
                </div>
              </td>
            </tr>
            <tr>
              <td className="feature-name">한글 이력서 생성</td>
              <td className="feature-value">
                <div className="value-content">
                  <span>1건</span>
                </div>
              </td>
              <td className="feature-value value-featured">
                <div className="value-content">
                  <span>무제한</span>
                </div>
              </td>
            </tr>
            <tr>
              <td className="feature-name">영문 이력서 자동 생성</td>
              <td className="feature-value">
                <div className="value-content">
                  <X className="feature-icon feature-excluded" />
                </div>
              </td>
              <td className="feature-value value-featured">
                <div className="value-content">
                  <span>무제한</span>
                </div>
              </td>
            </tr>
            <tr>
              <td className="feature-name">템플릿</td>
              <td className="feature-value">
                <div className="value-content">
                  <span>일반 템플릿</span>
                </div>
              </td>
              <td className="feature-value value-featured">
                <div className="value-content">
                  <span>프리미엄 템플릿 무제한</span>
                </div>
              </td>
            </tr>
            <tr>
              <td className="feature-name">PDF 다운로드</td>
              <td className="feature-value">
                <div className="value-content">
                  <span>1회</span>
                </div>
              </td>
              <td className="feature-value value-featured">
                <div className="value-content">
                  <span>무제한</span>
                </div>
              </td>
            </tr>
            <tr>
              <td className="feature-name">자기소개서 자동 생성</td>
              <td className="feature-value">
                <div className="value-content">
                  <X className="feature-icon feature-excluded" />
                </div>
              </td>
              <td className="feature-value value-featured">
                <div className="value-content">
                  <span>✓</span>
                </div>
              </td>
            </tr>
            <tr>
              <td className="feature-name">웹 포트폴리오 페이지</td>
              <td className="feature-value">
                <div className="value-content">
                  <X className="feature-icon feature-excluded" />
                </div>
              </td>
              <td className="feature-value value-featured">
                <div className="value-content">
                  <span>✓</span>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td className="footer-empty"></td>
              <td className="footer-action">
                <button className="pricing-button btn-free" onClick={handleFreeStart}>
                  무료로 시작하기
                </button>
              </td>
              <td className="footer-action footer-featured">
                <button className="pricing-button btn-pro" onClick={handleProUpgrade}>
                  Pro로 업그레이드
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* 팀/기업용 섹션 */}
      <div className="enterprise-section">
        <h2 className="section-title">팀·기업용(문의)</h2>
        <p className="section-subtitle">규모와 목적에 맞춘 맞춤형 견적 및 관리자 기능을 제공합니다.</p>
        
        <div className="enterprise-cards">
          {/* HR 패키지 */}
          <div className="enterprise-card">
            <div className="enterprise-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <h3 className="enterprise-title">HR 패키지</h3>
            <p className="enterprise-description">채취업 교육 대규모 인원용. 법적 요건 충족 리포트 포함.</p>
            
            <ul className="enterprise-features">
              <li>HR 전용 관리자 대시보드</li>
              <li>채취업 교육 수료 리포트(법적 증빙)</li>
              <li>지원자/후보자 계정 대량 발급 및 관리</li>
              <li>모든 Pro 기능 포함</li>
            </ul>
            
            <button className="enterprise-button" onClick={handleConsultingLearn}>
              상담 · 맞춤 견적
            </button>
          </div>

          {/* 리크루터 패키지 */}
          <div className="enterprise-card">
            <div className="enterprise-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
              </svg>
            </div>
            <h3 className="enterprise-title">리크루터 패키지</h3>
            <p className="enterprise-description">헤드헌터·에이전시용. 후보자 브랜딩 추천 리포트 제공.</p>
            
            <ul className="enterprise-features">
              <li>10 / 50 / 100+ 명 관리 티어</li>
              <li>리크루터 전용 후보자 관리 대시보드</li>
              <li>후보자 별 JD 맞춤 이력서/자소서 생성 기능 제공</li>
              <li>모든 Pro 기능 포함</li>
            </ul>
            
            <button className="enterprise-button" onClick={handleRecruitLearn}>
              상담 · 맞춤 견적
            </button>
          </div>
        </div>
      </div>

      {/* Enterprise Inquiry Modal */}
      <EnterpriseInquiryModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialPackage={selectedPackage}
      />
    </div>
  );
};

export default PricingPage;